import { render } from "./Padding.vue?vue&type=template&id=6b361c5c&scoped=true"
import script from "./Padding.vue?vue&type=script&lang=js"
export * from "./Padding.vue?vue&type=script&lang=js"

import "./Padding.vue?vue&type=style&index=0&id=6b361c5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b361c5c"]])

export default __exports__